// src/components/ui/SchoolProgramsHeader.jsx
//
// Page header for the school's GEFEN-programs screen (SchoolPrograms.jsx).
// Same gradient-card visual language as ProfileHeader.jsx — a
// blurred white glass panel over an indigo/purple/blue gradient, with
// an icon tile and a gradient-text title — but built as its own
// independent component (not a ProfileHeader variant). Title/subtitle
// only: the view toggle (My programs / Catalog) and the "join a
// program" button live in the page body below, not in the header.
import React from 'react';

const IconTicket = (
  <svg
    viewBox="0 0 24 24"
    className="w-5 h-5 sm:w-6 sm:h-6"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M4 9a2 2 0 100 4v3a2 2 0 002 2h12a2 2 0 002-2v-3a2 2 0 100-4V6a2 2 0 00-2-2H6a2 2 0 00-2 2v3z" />
    <path d="M9 4v16" strokeDasharray="2 2" />
  </svg>
);

const SchoolProgramsHeader = ({
  title = 'תוכניות גפ״ן',
  subtitle = 'ניהול תקציב, רכישה והנפקת קופונים לבית הספר',
}) => {
  return (
    <section className="mx-auto max-w-7xl px-2 sm:px-4 md:px-6 lg:px-8 py-3" dir="rtl">
      <div className="relative overflow-hidden rounded-2xl sm:rounded-3xl">
        <div className="absolute inset-0 bg-gradient-to-br from-indigo-50 via-purple-50 to-blue-50" />

        <div className="relative bg-white/80 backdrop-blur-xl border border-white/60 rounded-2xl sm:rounded-3xl p-4 sm:p-5 lg:p-6 shadow-2xl shadow-indigo-100/50">
          <div className="flex items-center gap-3 sm:gap-4">
            {/* Icon */}
            <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 rounded-xl sm:rounded-2xl bg-gradient-to-br from-indigo-500 to-purple-600 text-white flex items-center justify-center shadow-md">
              {IconTicket}
            </div>

            {/* Text */}
            <div className="min-w-0 flex-1">
              <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold bg-gradient-to-r from-gray-900 via-indigo-800 to-purple-800 bg-clip-text text-transparent leading-tight">
                {title}
              </h1>
              {subtitle && (
                <p className="text-sm sm:text-base text-gray-600 mt-0.5 sm:mt-1 line-clamp-2 sm:truncate">
                  {subtitle}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SchoolProgramsHeader;